<template lang="pug">
b-dropdown.m-2(variant="default")
  template(v-slot:button-content)
    i.fa.fa-list
    template(v-if="$store.state.report.custom_col_name == ''") 表示項目選択
    template(v-else) 列: {{ $store.state.report.custom_col_name }}
  b-dropdown-item-button(@click="clearCustomCol") デフォルト
  b-dropdown-item-button(v-for="custom_col in $store.state.report.saved_custom_cols",@click="select(custom_col)",:key="custom_col.id")
    | {{custom_col.name}}
    i.fa.fa-times(@click="remove(custom_col)")
  b-dropdown-divider
  b-dropdown-item-button(@click="showReportColModal")
    i.fa.fa-plus
    | 表示項目を変更
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
    showReportColModal(){
      this.$bvModal.show('modal-report-cols')
    },
    select(custom_col){
      this.$store.commit("report/selectCustomCol", custom_col)
    },
    clearCustomCol(){
      this.$store.commit("report/setCustomColName", "")
    },
    remove(custom_col){
      if(confirm("削除しますか？")){
        this.$store.dispatch("report/destroyCol",{custom_col_id: custom_col.id})
      }
    }
  },
  async mounted(){
    await Vue.nextTick()
  },
  watch: {
  },
  computed: {
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
i.fa.fa-list{
  margin-right:10px;
}
i.fa.fa-plus{
  margin-right:5px;
}
.dropdown-menu{
  li{
    position:relative;
    button{
      position:relative;
    }
    i.fa.fa-times{
      position:absolute;
      right:10px;
      top:8px;
    }
  }
}
</style>
